import React, { useContext, useEffect } from 'react'
import ContentHeader from '@Components/ContentHeader'
import { StoresContext } from '@App/contexts'
import CowriterSearch from '@Components/Search/CowriterSearch'
import { observer } from 'mobx-react'
import CowriterSearchHeader from '@Scenes/SongwriterScene/CowriterSearch/CowriterSearchScene/CowriterSearchHeader'

const CowriterSearchScene = () => {
    const { cowriterSearchPartyStore } = useContext(StoresContext)

    useEffect(() => {
        cowriterSearchPartyStore.resetStore()
    }, [])

    return (
        <>
            <title>Co-Writer Search</title>
            <div className="songwriter-catalog-wrapper">
                <ContentHeader title="Co-Writers" content={<CowriterSearchHeader />} />
                <CowriterSearch />
            </div>
        </>
    )
}

export default observer(CowriterSearchScene)
